/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input } from '@angular/core';
import { faCheckSquare, faSquare } from '@fortawesome/pro-regular-svg-icons';
import {
  QuestionAnswerRecordData,
  QuestionRecordData
} from '../../../../../../../../models/record/items/question-record.model';
@Component({
  selector: 'question-record',
  templateUrl: './question-record.component.html',
  styleUrls: ['./question-record.component.scss'],
  standalone: false
})
export class QuestionRecordComponent {
  @Input() record!: QuestionRecordData;
  faCheckSquare = faCheckSquare;
  faSquare = faSquare;

  constructor() {}

  getText(answer: QuestionAnswerRecordData, index: number): string {
    let answerString = $localize`:Answer:Answer`;
    let incidentString = $localize`:INCIDENT:INCIDENT`;
    return `${answerString} ${index + 1}: ${answer.answerText} ${
      answer.isTriggered ? `(${incidentString})` : ''
    }`;
  }
}
